import { Select, SelectProps } from "@mui/material";
import { TEXT_COLOR } from "../../lib/style_definitions";

type MSelectProps<Value = unknown> = Omit<
  SelectProps<Value>,
  "size" | "variant" | "MenuProps" | "sx"
> & {
  size?: "large" | "default";
};

export function MSelect<Value = unknown>({
  size = "default",
  ...props
}: MSelectProps<Value>) {
  return (
    <Select<Value>
      {...props}
      fullWidth
      variant="outlined"
      sx={{
        height: size === "large" ? 44 : 40,
        minWidth: 0,
        borderRadius: "14px",
        backgroundColor: "#f5f5f5",
        color: TEXT_COLOR,
        fontSize: 16,
        fontFamily: "inherit",
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          height: "100%",
          minHeight: 0,
          boxSizing: "border-box",
          padding: "0 36px 0 12px",
        },
        "& .MuiSelect-icon": { color: "#9ca3af" },
        "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            border: 0,
          },
      }}
      MenuProps={{
        sx: { zIndex: 6300 },
        onClick: (event) => event.stopPropagation(),
        slotProps: {
          paper: {
            sx: {
              marginTop: "4px",
              borderRadius: "14px",
              border: "1px solid #e5e7eb",
              color: TEXT_COLOR,
              fontFamily: "inherit",
              "& .MuiMenuItem-root": { fontFamily: "inherit", fontSize: 16 },
            },
          },
        },
      }}
    />
  );
}
